// Production API Configuration for PlatformRadar
// Using environment variable for flexible deployment
const API_BASE_URL = import.meta.env.DEV 
  ? '' // Use Vite proxy in development
  : (import.meta.env.VITE_API_URL || 'https://api.platformradar.io');

export const API_CONFIG = {
  baseURL: API_BASE_URL,
  timeout: 15000, // Increased timeout
  headers: {
    'Content-Type': 'application/json',
  },
};

export const API_ENDPOINTS = {
  health: '/health',
  onboarding: '/api/auth/onboarding',
  auth: {
    login: '/api/auth/login',
    register: '/api/auth/register',
    logout: '/api/auth/logout',
  },
  dashboard: '/api/dashboard/kpis',
  orders: '/api/orders',
  products: '/api/products',
  settings: '/api/settings',
  sync: '/api/sync',
};

export default API_CONFIG;
